export default __webpack_public_path__ + "static/media/phone.caa28441.svg";